import script from "./PageHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageHeader.vue?vue&type=script&lang=ts&setup=true"

import "./PageHeader.vue?vue&type=style&index=0&id=83f2abac&lang=scss"

const __exports__ = script;

export default __exports__